// extracted by mini-css-extract-plugin
export default {"swipeIndicator":"_633895d0","isVisible":"_c83fabbd","swipeIndicatorArrow":"_273938e9"};